{
    "common": {
        "mon": "Пн",
        "tue": "Вт",
        "wed": "Ср",
        "thu": "Чт",
        "fri": "Пт",
        "sat": "Сб",
        "sun": "Вс",
        "jan": "Янв",
        "feb": "Фев",
        "mar": "Мар",
        "apr": "Апр",
        "jun": "Июн",
        "jul": "Июл",
        "aug": "Авг",
        "sep": "Сен",
        "oct": "Окт",
        "nov": "Ноя",
        "dec": "Дек",
        "january": "Январь",
        "february": "Февраль",
        "march": "Март",
        "april": "Апрель",
        "may": "Май",
        "june": "Июнь",
        "july": "Июль",
        "august": "Август",
        "september": "Сентябрь",
        "october": "Октябрь",
        "november": "Ноябрь",
        "december": "Декабрь",
        "checkin": "Заезд",
        "checkout": "Выезд",
        "room": "Комната",
        "rooms": "Комнаты",
        "adult": "Взрослый",
        "adults": "Взрослые",
        "edit": "Редактировать",
        "editCap": "РЕДАКТИРОВАТЬ",
        "delete": "Удалить",
        "deleteCap": "УДАЛИТЬ",
        "localTime": "Местное Время",
        "back": "НАЗАД",
        "home": "ГЛАВНАЯ",
        "yes": "ДА",
        "no": "НЕТ",
        "left": "Осталось",
        "hour": "Час",
        "hours": "Часа",
        "night": "ночь",
        "nights": "ночи",
        "for": "за",
        "why": "Почему",
        "get": "Получите",
        "more": "Больше",
        "agree": "СОГЛАСЕН",
        "disagree": "НЕ СОГЛАСЕН",
        "basedOn": "на основе",
        "error": "Произошла ошибка, попробуйте позже",
        "error2": "Не удалось, попробуйте снова!",
        "error3": "Произошла Ошибка!!",
        "error4": "Произошла ошибка!! Пожалуйста, попробуйте снова",
        "error5": "Извините!! Произошла ошибка. Пожалуйста, попробуйте позже.",
        "hi": "Привет",
        "to": "в",
        "free": "Бесплатно",
        "per": "За",
        "at": "в",
        "day": "День",
        "days": "Дня",
        "time": "Время",
        "of": "из",
        "photo": "Фото",
        "photos": "Фото",
        "done": "Готово",
        "fullStay": "Вся Поездка",
        "date": "Дата",
        "and": "и",
        "bookingDetail": "Детали Бронирования",
        "Back": "Назад",
        "Home": "Главная"
    },
    "userPopup": {
        "myAccount": "Мой Аккаунт",
        "welcome": "Добро пожаловать",
        "user": "Пользователь",
        "findMyBookings": "НАЙТИ МОИ БРОНИРОВАНИЯ",
        "viewProfile": "ПОСМОТРЕТЬ ПРОФИЛЬ",
        "makeAReservarion": "СДЕЛАТЬ БРОНИРОВАНИЕ",
        "logout": "ВЫЙТИ",
        "loginCap": "ВОЙТИ",
        "login": "Войти",
        "invalidCredentials": "Неверные учетные данные",
        "invalidEmail": "Неверный Email",
        "passwordIsRequired": "Пароль обязателен",
        "minChar8": "минимум 8 символов",
        "tooShort": "Слишком коротко!",
        "tooLong": "Слишком длинно!",
        "required": "Обязательно",
        "emailInvalid": "Введите действительный email",
        "passwordInvalid": "Введите действительный пароль",
        "phNumInvalid": "Номер телефона недействителен",
        "signupCap": "ЗАРЕГИСТРИРОВАТЬСЯ",
        "signup": "Регистрация",
        "verifyText": "Подтвердите, что это вы",
        "verifyText2": "Мы отправили код подтверждения на ваш email",
        "verificationCode": "Код Подтверждения",
        "didNotReceiveEmail": "Не получили email",
        "clickToResend": "Нажмите, чтобы отправить повторно",
        "verifyAndSignIn": "Подтвердить и войти",
        "otpSentSuccessfully": "Код отправлен успешно",
        "somethingWentWrong": "Что-то пошло не так, попробуйте снова",
        "otpError": "Пожалуйста, введите действительный номер",
        "otpError2": "Пожалуйста, вводите только цифры",
        "otpError3": "Неверный код, попробуйте снова",
        "otpError4": "Код истек, нажмите Отправить повторно чтобы попробовать снова",
        "otpError5": "Попробуйте снова",
        "forgetPassword": "Забыли пароль",
        "submitError": "Пользователь не существует!",
        "userExistError": "Пользователь уже существует",
        "checkYourEmail": "Проверьте вашу почту",
        "passwordResetLinkSent": "Мы отправили ссылку для сброса пароля на",
        "noWorriesResetInstructions": "Не беспокойтесь, мы отправим вам инструкции по сбросу.",
        "enterYourEmail": "Введите ваш email",
        "resetMyPassword": "СБРОСИТЬ ПАРОЛЬ",
        "setANewPassword": "Установить новый пароль",
        "newPassword": "Новый Пароль",
        "confirmPassword": "Подтвердите Пароль",
        "confirmPasswordError": "Пароли должны совпадать",
        "backToLogin": "Вернуться к входу",
        "dontHaveAccount": "Нет аккаунта?",
        "alreadyHaveAccount": "Уже есть аккаунт?",
        "memberDiscount1": "Вы получите",
        "memberDiscount2": "скидку участника навсегда.",
        "discount1": "Управляйте всеми вашими бронированиями из одного места.",
        "discount2": "Зарегистрируйтесь для персонализированных рекомендаций и индивидуального опыта!!",
        "discount3": "Присоединяйтесь к нашему сообществу довольных гостей и начните планировать свое пребывание.",
        "leftGridText1": "Управляйте всеми вашими бронированиями из одного места",
        "leftGridText2": "Зарегистрируйтесь для персонализированных рекомендаций и индивидуального опыта!!",
        "leftGridText3": "Присоединяйтесь к нашему сообществу довольных гостей и начните планировать свое пребывание",
        "gridDiscountText1": "скидка участника на",
        "gridDiscountText2": "выбранных гостиницах навсегда",
        "gridDiscountText3": "Войдите для индивидуального опыта навсегда",
        "gridDiscountText4": "Получите Эксклюзивные Привилегии Участника",
        "findBookingError": "Ваш email и идентификатор бронирования не совпадают",
        "verifyAndConfirmBooking": "Подтвердите и подтвердите бронирование",
        "confirmEmailText": "Мы отправили код подтверждения на ваш адрес электронной почты",
        "enterCodeText": "Пожалуйста, введите код подтверждения, отправленный вам",
        "didNotRecieveEmail": "Не получили email?",
        "changeEmailText": "Нажмите здесь, чтобы изменить адрес электронной почты",
        "verifyAndConfirm": "Подтвердить и Подтвердить",
        "verified": "ПОДТВЕРЖДЕНО",
        "bookingExpired": "Бронирование Истекло",
        "bookingExpiredText": "Извините, идентификатор бронирования, который вы используете, истек",
        "backToFindingBooking": "Вернуться к поиску бронирования",
        "findMyBooking": "Найти Мои Бронирования",
        "bookingEmail": "Email Бронирования",
        "reservationId": "Номер Бронирования",
        "findBooking": "НАЙТИ БРОНИРОВАНИЕ",
        "abandonmentCartDoneText1": "Спасибо!",
        "abandonmentCartDoneText2": "Детали вашей корзины были отправлены на email. Продолжите бронирование в любое время.",
        "Recommended Currencies": "Рекомендуемые Валюты",
        "All currencies": "Все валюты",
        "thisIsRequiredField": "Это обязательное поле"
    },
    "widget": {
        "destination": "Направление",
        "enterDestination": "ВВЕДИТЕ НАПРАВЛЕНИЕ",
        "guests": "Гости",
        "guest": "Гость",
        "nationality": "Национальность",
        "selectNationality": "Выберите национальность",
        "nationalityIsRequired": "Национальность обязательна",
        "selectedRate": "Специальный тариф",
        "search": "Поиск",
        "ages": "Возраст",
        "orAbove": "Или Старше",
        "child": "Ребенок",
        "children": "Дети",
        "addAnotherRoom": "Добавить Еще Комнату",
        "removeRoom": "Удалить Комнату",
        "property": "Гостиница",
        "city": "Город",
        "country": "Страна",
        "bookNow": "Забронировать Сейчас",
        "overnightStay": "Ночное Пребывание",
        "dayUse": "Дневное Использование",
        "destinationIsRequired": "Направление обязательно",
        "checkInIsRequired": "Дата начала обязательна",
        "checkOutIsRequired": "Дата окончания обязательна",
        "noLocationFound": "Место не найдено",
        "soldOut": "Продано",
        "highDemand": "Высокий Спрос",
        "dates": "Даты",
        "allRates": "Все ставки в",
        "K": "К",
        "M": "М",
        "sameDayCheckout": "Выезд в тот же день"
    },
    "promotion": {
        "headingText": "Важная Информация для",
        "regularRate": "Нет",
        "seniorCitizen": "Тариф Пенсионеров",
        "agencyRate": "Тариф Агентства",
        "caaRate": "Тариф CAA/AAA",
        "corporateRate": "Корпоративный Тариф",
        "governmentRate": "Правительственный/Военный Тариф",
        "promotionalSpecialRate": "Промо/Специальный Тариф",
        "regularRateDescription": "Промоакция не применена.",
        "seniorCitizenRateDescription": "Это сниженный гостиничный тариф, широко доступный для пожилых людей, обычно в возрасте 60 лет и старше.",
        "agencyRateDescription": "Это сниженный гостиничный тариф, который предлагается и доступен только через определенных турагентов, способствуя партнерству и сотрудничеству.",
        "caaRateDescription": "Это специальный гостиничный тариф, предлагаемый членам AAA или CAA для эксклюзивных сбережений.",
        "corporateRateDescription": "Это сниженный гостиничный тариф, предоставляемый деловым путешественникам, обычно согласованный между гостиницей и корпоративным объектом.",
        "governmentRateDescription": "Этот тарифный план предлагает конкретные скидки для персонала Правительства/Военных для бронирования гостиничного номера.",
        "contentSeniorCitizen": "Доказательство даты рождения обязательно при заезде. Отсутствие присущего подтверждения личности приведет к взиманию преобладающих тарифов.",
        "contentAgencyRate": "Убедитесь, что у вас есть подтверждение бронирования и удостоверение личности при прибытии. Непредставление этих документов приведет к применению стандартных тарифов.",
        "contentPromotionalSpecialRate": "Это сниженный гостиничный тариф, предлагаемый на ограниченное время, часто связанный с определенными событиями, сезонами или маркетинговыми кампаниями.",
        "contentCaaRate": "Пожалуйста, убедитесь, что у вас есть карта членства CAA или соответствующее удостоверение личности при заезде. Отсутствие присущего подтверждения личности приведет к взиманию преобладающих тарифов.",
        "contentCorporateRate": "Доказательство корпоративного удостоверения личности или другой официальной документации требуется при заезде. Отсутствие присущего доказательства приведет к взиманию преобладающих тарифов.",
        "contentGovernmentRate": "Действительное правительственное или военное удостоверение личности должно быть предоставлено при заезде. Отсутствие необходимого удостоверения личности приведет к взиманию платы по стандартному тарифу.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "ПРИМЕНИТЬ",
        "Offer Code": "Код Предложения",
        "Agency Code": "Код Агентства",
        "Corporate Code": "Корпоративный Код",
        "All-Access Rate": "Тариф Полного Доступа",
        "errorCode": "Этот Код недействителен"
    }
}

